import * as React from "react";

export const MathIcon = ({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Root-like symbol */}
    <path d="M4 15l3-8 3 8" />
    <path d="M9 15h3" />
    {/* Small x to suggest equation */}
    <path d="M15 10l4 4" />
    <path d="M19 10l-4 4" />
  </svg>
);

export default MathIcon;

